<template>
  <el-container>
    <el-aside width="200px">
      <el-menu
        ref="menu"
        class="menu navigator"
        :default-active="active"
        text-color="#fff"
        :default-openeds="defaultOpends"
        @select="changeSelect"
        router
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-info"></i> 用户权限
          </template>
          <el-menu-item index="/backstage-management/admin/usercenter"
            >用户管理</el-menu-item
          >
          <el-menu-item index="/backstage-management/admin/role"
            >权限管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-info"></i> 风电场规划
          </template>
          <el-menu-item index="/backstage-management/wind/owner"
            >业主列表</el-menu-item
          >
          <el-menu-item index="/backstage-management/wind/resource"
            >机型设置</el-menu-item
          >
          <el-menu-item index="/backstage-management/wind/tower"
            >推荐测风塔</el-menu-item
          >
          <el-menu-item index="/backstage-management/wind/selection"
            >选型布机</el-menu-item
          >
          <el-menu-item index="/backstage-management/wind/electric"
            >电量计算</el-menu-item
          >
          <el-menu-item index="/backstage-management/wind/base"
            >基地管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-info"></i> 财务模块
          </template>
          <el-menu-item index="/backstage-management/finance"
            >财务评价</el-menu-item
          >
          <el-menu-item index="/backstage-management/economic"
            >总投资概算</el-menu-item
          >
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-info"></i> 测风模块
          </template>
          <!-- <el-menu-item index="/backstage-management/anemometry"
            >要素范围</el-menu-item
          > -->
          <el-menu-item index="/backstage-management/email"
            >邮箱配置</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="/backstage-management/industry">
          <i class="el-icon-info"></i>行业动态
        </el-menu-item>
        <el-menu-item index="/backstage-management/mesoscale">
          <i class="el-icon-info"></i>中尺度订正
        </el-menu-item>
        <el-menu-item index="/backstage-management/feedback">
          <i class="el-icon-info"></i>反馈管理
        </el-menu-item>
      </el-menu></el-aside
    >
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
// import UserCenter from './admin/usercenter';
// import Role from './admin/role';

export default {
  // components: {
  //   UserCenter,
  //   Role,
  // },
  data() {
    return {
      active: '1-1',
      isCollapse: true,
      defaultOpends: ['1']
    };
  },
  watch: {
    active(val) {
      console.log(val);
    }
  },
  methods: {
    changeSelect(index) {
      this.active = index;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key >= keyPath);
      console.log(key, keyPath);
    }
  }
};
</script>

<style lang="less" scoped>
.el-container {
  height: 100%;

  .el-aside {
    overflow-x: hidden;
    background-color: @bgColor;

    /deep/.el-menu {
      background-color: @bgColor;
      border: none;
      .el-submenu {
        background-color: @bgColor;
        .el-submenu__title {
          &:focus,
          &:hover {
            color: white;
            background: @bgColor !important;
          }
        }
        &.is-active {
          .el-submenu__title {
            color: white;
            background: @bgColor;
            border-bottom-color: #ffd04b;
          }
        }
      }
      .el-menu-item {
        &:focus,
        &:hover {
          color: white;
          background: @bgColor;
        }
        &.is-active {
          color: #ffd04b;
          border-bottom-color: #ffd04b;
        }
      }
      &.navigator {
        .el-menu-item {
          &:focus,
          &:hover {
            color: white;
            background: @bgColor;
          }
          &.is-active {
            color: #ffd04b;
            border-bottom-color: #ffd04b;
          }
        }
      }
    }
  }

  .el-main {
    padding: 0;
  }
}
</style>
<style lang="less">
@import './index.less';
</style>
